export * from './lib/vehicle-assignment';